export { default as IdentificationNewUser } from "./identification-new-user.vue"
export { default as UserIdentificationLegal } from "./user-identification-legal.vue"
